module.exports = __webpack_public_path__ + "img/search.6af00b7f.svg";